import { Helmet } from "react-helmet-async";
import { getPublicSiteUrl } from "@/utils/publicSiteUrl";

type PublicSeoProps = {
  title: string;
  description: string;
  path?: string;
  noindex?: boolean;
  imageUrl?: string | null;
};

export function PublicSeo({
  title,
  description,
  path = "/",
  noindex = false,
  imageUrl,
}: PublicSeoProps) {
  const siteUrl = getPublicSiteUrl();
  const canonicalPath = path.startsWith("/") ? path : `/${path}`;
  const canonicalUrl = siteUrl ? `${siteUrl}${canonicalPath}` : undefined;
  const ogImage =
    imageUrl && /^https?:\/\//i.test(imageUrl)
      ? imageUrl
      : siteUrl
        ? `${siteUrl}/images/og-global.png`
        : undefined;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
